import { getAllBlogs } from "@/queries";

export const fetchAllBlogPosts = async (_after = null, accumulatedPosts = []) => {
  const endpoint =
    process.env.NEXT_PUBLIC_WP_GRAPHQL_ENDPOINT || process.env.WP_GRAPHQL_ENDPOINT;
  const user = process.env.BASIC_AUTH_USER;
  const pass = process.env.BASIC_AUTH_PASSWORD;

  if (!endpoint || !user || !pass) {
    console.error("Missing required env vars for WP GraphQL endpoint or Basic Auth.");
    return accumulatedPosts;
  }

  const toBase64 = (str) =>
    typeof btoa === "function" ? btoa(str) : Buffer.from(str).toString("base64");

  // Per-type fields + their "after" variables from the query
  const keys = [
    { field: "news", v: "afterNews" },
    { field: "successStories", v: "afterSuccess" },
    { field: "insights", v: "afterInsights" },
    { field: "webinars", v: "afterWebinars" },
    { field: "projectThrives", v: "afterProjectThrive" },
    { field: "podcasts", v: "afterPodcasts" },
  ];

  const variables = keys.reduce((acc, k) => ((acc[k.v] = null), acc), {});
  const hasNext = keys.reduce((acc, k) => ((acc[k.field] = true), acc), {});

  const allEdges = Array.isArray(accumulatedPosts) ? [...accumulatedPosts] : [];
  const seen = new Set(
    allEdges
      .map((e) => e?.node?.id || e?.node?.uri || e?.cursor)
      .filter(Boolean)
  );

  while (Object.values(hasNext).some(Boolean)) {
    const search = new URLSearchParams({
      query: getAllBlogs,
      variables: JSON.stringify(variables),
    });

    const url = `${endpoint}?${search.toString()}`;

    const res = await fetch(url, {
      method: "GET",
      next: { revalidate: 2400 },
    });

    if (!res.ok) {
      console.error("API Error", res.status, res.statusText);
      break;
    }

    let json;
    try {
      json = await res.json();
    } catch (e) {
      console.error("Failed to parse GraphQL response JSON", e);
      break;
    }

    if (json?.errors?.length) {
      console.error("GraphQL Errors:", json.errors);
    }

    const data = json?.data || {};

    keys.forEach(({ field, v }) => {
      if (!hasNext[field]) return;

      const conn = data[field];
      if (!conn) {
        hasNext[field] = false;
        variables[v] = null;
        return;
      }

      const edges = Array.isArray(conn.edges) ? conn.edges : [];
      for (const edge of edges) {
        const key = edge?.node?.id || edge?.node?.uri || edge?.cursor;
        if (key && !seen.has(key)) {
          seen.add(key);
          allEdges.push(edge);
        }
      }

      const pageInfo = conn.pageInfo || {};
      hasNext[field] = !!pageInfo.hasNextPage;
      variables[v] = pageInfo.hasNextPage ? pageInfo.endCursor || null : null;
    });
  }

  return allEdges;
};
